import cn from 'classnames';
import React, { useState } from 'react';

import SvgCheck from '@sats-group/icons/18/check';
import Chip from '@sats-group/ui-lib/react/chip';
import Select from '@sats-group/ui-lib/react/select';
import Text from '@sats-group/ui-lib/react/text';

import type { StartDate as Props } from './start-date.types';

const StartDate: React.FC<Props> = ({
  defaultValue,
  label,
  select,
  startDates,
}) => {
  const [selectedStartDate, setSelectedStartDate] = useState<
    string | undefined
  >(defaultValue ?? startDates[0]?.value);

  return (
    <div className="start-date">
      <fieldset className="start-date__fieldset">
        <legend>
          <Text theme="emphasis">{label}</Text>
        </legend>
        <div className="start-date__buttons">
          {startDates.map(startDate => (
            <Chip
              customIcon={<SvgCheck />}
              elementName="button"
              isSelected={selectedStartDate === startDate.value}
              key={startDate.value}
              onClick={() => setSelectedStartDate(startDate.value)}
              text={startDate.text}
              type="button"
            />
          ))}
        </div>
        <div
          className={cn('start-date__select', {
            'start-date__select--visible':
              selectedStartDate !== startDates[0]?.value &&
              selectedStartDate !== startDates[1]?.value,
          })}
          inert={
            selectedStartDate === startDates[0]?.value ||
            selectedStartDate === startDates[1]?.value
              ? true
              : undefined
          }
        >
          <Select
            {...select}
            name="startDate"
            id="startDate"
            wide={true}
            value={selectedStartDate}
            onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
              setSelectedStartDate(event.target.value)
            }
          />
        </div>
      </fieldset>
    </div>
  );
};

export default StartDate;
